import {createSimpleAction, createTypeAction} from "../utils/actionUtils";

// Resource filter (non-settings - stays in Redux)
export const CHANGE_CALENDAR_SELECTED_LOCATION = 'CHANGE_CALENDAR_SELECTED_LOCATION'
export const changeCalendarSelectedLocationAction = createSimpleAction(CHANGE_CALENDAR_SELECTED_LOCATION, 'tatortId')

// Event filter (non-settings - stays in Redux)
export const CHANGE_CALENDAR_EVENT_FILTER = 'CHANGE_CALENDAR_EVENT_FILTER'
export const changeCalendarEventFilterAction = createSimpleAction(CHANGE_CALENDAR_EVENT_FILTER, 'eventFilter')

// Customer search UI state (non-settings - stays in Redux)
export const SET_CALENDAR_CUSTOMER_SEARCH_STATE = 'SET_CALENDAR_CUSTOMER_SEARCH_STATE'
export const CLEAR_CALENDAR_CUSTOMER_SEARCH_STATE = 'CLEAR_CALENDAR_CUSTOMER_SEARCH_STATE'

/**
 * Updates the customer search UI state with partial changes.
 * The reducer will merge the provided fields into the existing state.
 * @param {Object} customerSearchState - Partial customer search state ({ searchString, settings, selectedSearchedKundId })
 */
export const setCalendarCustomerSearchStateAction =
    createSimpleAction(SET_CALENDAR_CUSTOMER_SEARCH_STATE, 'customerSearchState')

/**
 * Clears the customer search UI state back to its initial values.
 * Note: This affects only UI state, not server-side search results (TanStack Query).
 */
export const clearCalendarCustomerSearchStateAction = createTypeAction(CLEAR_CALENDAR_CUSTOMER_SEARCH_STATE)

// Termin/Kunde selection (non-settings - stays in Redux)
export const CHANGE_CALENDAR_SELECTED_TERMIN_WITH_CONTEXT = 'CHANGE_CALENDAR_SELECTED_TERMIN_WITH_CONTEXT'
export const CHANGE_CALENDER_SELECTED_KUND_ID = 'CHANGE_CALENDER_SELECTED_KUND_ID'
export const CLEAR_CALENDAR_SELECTED_TERMIN_ID = 'CLEAR_CALENDAR_SELECTED_TERMIN_ID'

export const clearCalendarSelectedTermin = createTypeAction(CLEAR_CALENDAR_SELECTED_TERMIN_ID)
export const changeCalenderSelectedKundIDAction = createSimpleAction(CHANGE_CALENDER_SELECTED_KUND_ID, 'selectedKundID')

/**
 * Action to select a termin with context for intelligent clearing.
 * Context stores { artistId, start } to detect when manual view changes should clear the marker.
 * @param {Object} payload - { terminId, kundId?, context: { artistId, start } }
 */
export const changeCalendarSelectedTerminWithContextAction = createSimpleAction(CHANGE_CALENDAR_SELECTED_TERMIN_WITH_CONTEXT, 'selection')
